class Filter {
	category = '*';
	$filteredItems = [];
	stateClasses = {
		firstItem: 'first-item',
	};
	constructor($el) {
		this.$el = $el;
		this.$triggers = $el.find('[data-filter="trigger"]');
		this.$items = $el.find('[data-filter="item"]');
		this.hasLoadMore = $el.data('offset') ? true : false;
		if (this.hasLoadMore) {
			this.$loadMore = $el.find('[data-filter="load-more"]');
		}
		this.offset = parseInt($el.data('offset'));

		this.init();
	}

	init = () => {
		this.$triggers.on('change', this.filterChangeHandler);
		if (this.hasLoadMore) {
			this.$loadMore.on('click', this.loadMore);
		}
		this.filterItems();
	};

	filterChangeHandler = e => {
		const newCategory = e.target.value;
		if (this.category !== newCategory) {
			this.$items.addClass('d-none');
			this.$items.removeClass(this.stateClasses.firstItem);
			this.category = newCategory;
			this.filterItems();
		}
	};

	filterItems = () => {
		console.log('filter items');
		console.log('this.$items', this.$items);
		if (this.category != '*') {
			const itemArray = this.$items.toArray();
			this.filteredItems = itemArray.filter(item => {
				return $(item).data('categories').includes(parseInt(this.category));
			});
		} else {
			this.filteredItems = this.$items.toArray();
		}

		$(this.filteredItems[0]).addClass(this.stateClasses.firstItem);

		if (this.hasLoadMore) {
			this.loadMore();
		} else {
			this.loadAll();
		}
	};

	loadMore = () => {
		for (let i = 0; i < this.offset && this.filteredItems.length; i++) {
			const item = this.filteredItems.shift();
			$(item).removeClass('d-none');
		}

		if (this.filteredItems.length === 0) {
			this.$loadMore.addClass('d-none');
		} else {
			this.$loadMore.removeClass('d-none');
		}
	};

	loadAll = () => {
		$(this.filteredItems).removeClass('d-none');
	};
}

export default Filter;
